import { ClickAwayListener } from '@material-ui/core';
import clsx from 'clsx';
import React, { useState } from 'react';
import { formatPhoneNumber } from 'react-phone-number-input';

import ContainerWithPatternStyled from 'components/BrandingHelpers/ContainerWithPatternStyled';
import Title from 'components/curo-components/common/Title';
import Typography from 'components/curo-components/common/Typography';
import ActionPopUp from 'components/digifi-wrappers/ActionPopUp';
import ActionPopUpItem from 'components/digifi-wrappers/ActionPopUpItem';
import { ArrowDownIcon, UserIcon } from 'static/images';

import styles from './BorrowerDetailsPopUp.module.scss';

interface IBorrowerDetailsPopUpProps {
  borrowerName: string;
  borrowerEmail: string;
  borrowerPhone: string;
  onLogoutClick: () => void;
}

const BorrowerDetailsPopUp = ({
  borrowerName,
  onLogoutClick,
  borrowerEmail,
  borrowerPhone,
}: IBorrowerDetailsPopUpProps) => {
  const [isActionPopUpOpen, setIsActionPopUpOpen] = useState<boolean>(false);

  const handleClick = () => {
    setIsActionPopUpOpen(true);
  };

  const handleClose = () => {
    setIsActionPopUpOpen(false);
  };

  const handleLogoutClick = () => {
    onLogoutClick();
  };

  const renderActionPopUp = () => {
    return (
      <ClickAwayListener onClickAway={handleClose}>
        <div className={styles.actionPopUpContainer}>
          <ActionPopUp title={borrowerName} onClose={handleClose}>
            <div className={styles.contactsWrapper}>
              <div className={styles.contactItem}>
                <Typography>Email Address:</Typography>
                <Title type="h6">{borrowerEmail}</Title>
              </div>
              <div className={styles.contactItem}>
                <Typography>Cell Phone Number:</Typography>
                <Title type="h6">{formatPhoneNumber(borrowerPhone)}</Title>
              </div>
            </div>
            <ActionPopUpItem danger onClick={handleLogoutClick}>
              Sign Out
            </ActionPopUpItem>
          </ActionPopUp>
        </div>
      </ClickAwayListener>
    );
  };

  const renderBorrowerName = () => {
    return (
      <>
        <div className={styles.borrowerName}>{borrowerName}</div>
        <ArrowDownIcon className={styles.arrowIcon} />
      </>
    );
  };

  return (
    <div className={clsx(styles.borrowerDetailsContainer)}>
      <div className={styles.borrowerDetailsContainer} onClick={handleClick}>
        <ContainerWithPatternStyled className={styles.iconContainer}>
          <UserIcon />
        </ContainerWithPatternStyled>
        {renderBorrowerName()}
      </div>
      {isActionPopUpOpen && renderActionPopUp()}
    </div>
  );
};

export default BorrowerDetailsPopUp;
